import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    margin: "20px 0px",
  },
  heading: {
    fontSize: "16px",
    letterSpacing: "2px",
    fontWeight: "700",
    textAlign: "left",
    color: "#222",
    textTransform: "uppercase",
  },
  item: {
    width: "210px",
    height: "180px",
  },
  imgContainer: {
    position: "relative",
    display: "flex",
    width: "210px",
    height: "100px",
    overflow: "hidden",
  },
  img: {
    width: "100px",
    marginBottom: "-100px",
    marginLeft: "2px",
  },
  text: {
    fontSize: "15px",
    color: "#666",
  },
  vs: {
    position: "absolute",
    top: "50%",
    left: "50%",
    backgroundColor: "#fff",
    padding: "8px",
    fontSize: "15px",
    fontWeight:'700',
    borderRadius: "50px",
    transform: "translate(-50%,-50%)",
  },
}));
